import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'
import content from './modules/content'
import login from './modules/login'
import candidateProfile from './modules/candidateProfile'
import user from './modules/user'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  actions,
  getters,
  modules: {
    content,
    login,
    candidateProfile,
    user
  },
  strict: debug,
  plugins: [createPersistedState({ storage: window.sessionStorage })]
})



// WEBPACK FOOTER //
// ./src/store/index.js